import { CommonModule } from '@angular/common';
import { Component, NgZone, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppAvailability } from '@awesome-cordova-plugins/app-availability/ngx';
import { IonicModule, ModalController, Platform } from '@ionic/angular';
import { Article, SerialNumber } from 'src/app/_interfaces/article';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { FeedbackService, MsgType } from 'src/app/_provider/feedback.service';
import { WawiConnectorService } from 'src/app/_provider/wawi-connector/wawi-connector.service';

@Component({
  selector: 'app-article-edit',
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule],
  templateUrl: './article-edit.component.html',
  styleUrls: ['./article-edit.component.scss'],
})
export class ArticleEditComponent implements OnInit {

  public article: Article
  public serialNumberText: string = ""

  public isNew: boolean = true

  public get serialNumberCount(): number{
    return this.article.serialNumbers.reduce((acc, cur) => acc + cur.quantity, 0) ?? 0
  }

  constructor(
    private modalCtrl: ModalController,
    private ngZone: NgZone,
    private feedback: FeedbackService,
    public platform: Platform,
    public wawiConnectorSrv: WawiConnectorService
  ) { }

  async ngOnInit() {
    await this.wawiConnectorSrv.initConnector()
  }

  public async close(){
    await this.modalCtrl.dismiss(null, null, "articleEdit")
  }

  public deleteSerialNumber(serialNumber: SerialNumber){
    this.ngZone.run(() => {
      this.article.serialNumbers = this.article.serialNumbers.filter(s => s != serialNumber)
    })
  }

  public addSerialNumber(){
    if(!this.serialNumberText) return
    this.ngZone.run(() => {
      this.article.serialNumbers.unshift({ serialNumber: this.serialNumberText, quantity: 1})
      this.serialNumberText = ""
    })
  }

  public async save(){
    if(this.article?.quantity <= 0) return await this.feedback.showError("Bitte geben Sie eine gültige Anzahl ein.")
    
    if(this.article.toCalculate && this.article.serialNumbersRequired && this.serialNumberCount != this.article.quantity)
      if(!(await this.feedback.confirm("Die Anzahl der Seriennummern stimmt nicht mit der Anzahl der Artikel überein. Möchten Sie trotzdem fortfahren?", "Fortfahren", "Abbrechen"))) return

    await this.feedback.hideKeyboardOnIOS()
    await this.modalCtrl.dismiss(this.article, null, "articleEdit")
  }

  public async scanSerialNumber(){
    const result: HttpFunctionResult<string> = await this.feedback.getQRCodeData()
    if(!result.data) return

    this.serialNumberText = result.data
    this.addSerialNumber()

  }

  public async openArticle(){
    if(this.wawiConnectorSrv.connector.executable){
      const openResult: HttpFunctionResult = await this.wawiConnectorSrv.connector.openArticle(this.article.id);
      if(openResult.success) this.feedback.showInformationToast(`Artikel wurde in ${this.wawiConnectorSrv.appName} geöffnet.`, "Information", 2000);
      else this.feedback.showError(openResult.message)
    }
  }

}
